// @flow
import { EVENT_FORM } from 'Client/cms/toolkit/constants';
import { EventFormLine } from 'Components/lines/event-form-line/EventFormLine';
import { eventFormResolver } from './eventForm.resolver';

export const eventFormDescriptor = {
  name: EVENT_FORM,
  component: EventFormLine,
  resolve: eventFormResolver.resolve,
};
